const getGoogleMapsUrl = (address, suburb, state, postCode) => {
  if (!address || address.trim().toLowerCase() === 'unknown') return ''

  const query = [address, suburb, state, postCode].filter(Boolean).join(', ')

  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`
}

export default getGoogleMapsUrl
